var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomei(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 33.9997V20.3042C37.5001 19.3513 37.3057 18.4085 36.9286 17.5334C36.5516 16.6584 35.9999 15.8695 35.3072 15.2152L22.4045 3.02115C21.7547 2.40678 20.8943 2.06445 20 2.06445C19.1057 2.06445 18.2453 2.40678 17.5955 3.02115L4.69275 15.2152C4.00014 15.8695 3.44842 16.6584 3.07137 17.5334C2.69433 18.4085 2.4999 19.3513 2.5 20.3042V33.9997C2.5 34.9279 2.86875 35.8181 3.52513 36.4745C4.1815 37.1309 5.07174 37.4997 6 37.4997H34C34.9283 37.4997 35.8185 37.1309 36.4749 36.4745C37.1313 35.8181 37.5 34.9279 37.5 33.9997Z",
    stroke: "#CECECE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomei);
export default __webpack_public_path__ + "static/media/Homei.945fe87253f78f21cd1b3ed32ea2b7ac.svg";
export { ForwardRef as ReactComponent };